import { render } from "./ForgotPassordPortal.vue?vue&type=template&id=1b467855&scoped=true"
import script from "./ForgotPassordPortal.vue?vue&type=script&lang=js"
export * from "./ForgotPassordPortal.vue?vue&type=script&lang=js"

import "./ForgotPassordPortal.vue?vue&type=style&index=0&id=1b467855&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b467855"]])

export default __exports__